import { useSyncExternalStore } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "kr-theme";
const listeners = new Set();

const getTheme = () => {
  try { return localStorage.getItem(KEY) || "light"; } catch { return "light"; }
};

const setTheme = (t) => {
  try { localStorage.setItem(KEY, t); } catch {}
  document.documentElement.classList.toggle("dark", t === "dark");
  listeners.forEach((l) => l());
};

export const useTheme = () =>
  useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, getTheme);

export const ThemeToggle = ({ className = "" }) => {
  const theme = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      onClick={() => setTheme(dark ? "light" : "dark")}
      title={dark ? "Hell" : "Dunkel"}
      aria-label="Farbmodus umschalten"
      className={`rounded-full border border-slate-200 p-2 text-slate-600 transition-colors hover:bg-slate-100 ${className}`}
      data-testid="theme-toggle-btn"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
